import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "suv"
const SuvIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.027 15.401H7.973a3 3 0 0 1-5.952-.755L1 13.8V12h1v-1H1l2-2.347V7h11l3.764 2.457L22 10c.646 0 .875.434.956 1H21v1h2v2l-.263.737a1 1 0 0 1-.942.664h-.822a3 3 0 0 1-5.946 0ZM4.5 8.5h9L16 10H4l.5-1.5Zm15 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM5 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
          />
        </svg>
      }
    </span>
  )
}
export default SuvIcon
